import * as React from "react";

import {Route, Switch} from "react-router-dom";
import BsPdfUpload from "bs-pdf-upload";
import CreditReportAnalysis from "creditreport";
import InsuranceV2 from "InsuranceV2";
import ReferralLink from "referral";
import Consent from "consent";
import UserformV3 from "userform/loanIndex";
import Userform from "userform";
import Timer from "components/common/timer";
import EGold from "egold";
import LoanApplication from "loan-application";
import IncompleteInfo from "IncompleteInfoV2";
import Loans from "Loans";
import BankStatementRedirect from "IncompleteInfoV2/BankStatementRedirect";
import Setu from "setu";

export function AppRoutes(version: number) {
    return (
        <Switch>
            <Route exact path="/:id?/userForm" component={version === 2 ? Userform : UserformV3}/>
            <Route path="/:id?/incomplete-info" component={IncompleteInfo}/>
            <Route path="/:id?/repaymentinfo" component={Loans}/>
            <Route path="/:id?/loans" component={Loans}/>
            <Route path="/:id?/setu" component={Setu}/>
            <Route exact path=":id?/bs-pdf-upload" component={BsPdfUpload}/>
            <Route exact path="/:id?/creditReport" component={CreditReportAnalysis}/>
            <Route exact path="/:id?/timer" component={Timer}/>
            <Route path="/:id?/consent" component={Consent}/>
            <Route path="/:id?/insurance" component={InsuranceV2}/>
            <Route path="/:id?/egold" component={EGold}/>
            <Route exact path={`/:id?/perfioes/redirect`} component={BankStatementRedirect}/>
            <Route exact path={`/:id?/bank-statement/redirect`} component={BankStatementRedirect}/>
            <Route exact path="/:id?/referralLink" component={ReferralLink}/>
            <Route path="/:id?/loan-application" component={LoanApplication}/>
            <Route exact path="/:id?/" component={version === 2 ? Userform : UserformV3}/>
        </Switch>
        );
}
